// extracted by mini-css-extract-plugin
export var equalColumn = "_fe-0";